"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCriteoProductDataPlugin = void 0;
function transform(ctx) {
    var _a, _b, _c;
    const events = ['lead', 'salable', 'traversal'];
    const incomingEvent = `${(_a = ctx.event) === null || _a === void 0 ? void 0 : _a.event}`.toLowerCase();
    try {
        if (events.includes(incomingEvent)) {
            const originalEventProperties = (_c = (_b = ctx.event) === null || _b === void 0 ? void 0 : _b.properties) !== null && _c !== void 0 ? _c : {};
            switch (incomingEvent) {
                case 'traversal':
                    const product = {
                        product_id: originalEventProperties === null || originalEventProperties === void 0 ? void 0 : originalEventProperties.purpose,
                        price: originalEventProperties === null || originalEventProperties === void 0 ? void 0 : originalEventProperties.amount,
                    };
                    ctx.updateEvent('properties', Object.assign(Object.assign({}, product), originalEventProperties));
                    break;
                case 'lead':
                case 'salable':
                default:
                    const products = {
                        products: [
                            {
                                product_id: originalEventProperties === null || originalEventProperties === void 0 ? void 0 : originalEventProperties.purpose,
                                price: originalEventProperties === null || originalEventProperties === void 0 ? void 0 : originalEventProperties.amount,
                                quantity: 1,
                            },
                        ],
                    };
                    ctx.updateEvent('properties', Object.assign(Object.assign({}, products), originalEventProperties));
                    break;
            }
        }
    }
    catch (e) {
        console.log(e);
    }
    return ctx;
}
exports.addCriteoProductDataPlugin = {
    name: 'Criteo Product Data',
    type: 'enrichment',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    track: transform,
};
//# sourceMappingURL=addCriteoProductData.js.map